import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { formatPrice } from '../utils/currency';
import { Xmark, NavArrowLeft, NavArrowRight } from 'iconoir-react';

function UpselModal({ show, onHide, products, onSelectProduct, onGoToCart, loading }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [indoParaCarrinho, setIndoParaCarrinho] = useState(false);
  
  const getImageUrl = (produto) => {
    if (produto.imagem?.imagem) {
      return `https://grubupload.s3.amazonaws.com/${produto.imagem.imagem}`;
    }
    return 'https://grubicons.s3.us-east-1.amazonaws.com/foto-padrao-grub-digital.jpg';
  };

  const handleNext = () => {
    if (currentIndex < products.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const currentProduct = products[currentIndex];

  return (
    <Modal show={show} onHide={onHide} centered size="md" style={{ zIndex: 1055 }}>
      <div style={{ position: 'relative', backgroundColor: '#fff', borderRadius: '16px', overflow: 'hidden' }}>
        {/* Header */}
        <div style={{ padding: '24px 24px 16px', borderBottom: '1px solid #e5e7eb', backgroundColor: '#fff' }}>
          <button
            onClick={onHide}
            style={{
              position: 'absolute',
              top: '16px',
              right: '16px',
              background: '#f3f4f6',
              border: 'none',
              cursor: 'pointer',
              padding: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '8px',
              transition: 'background 0.2s'
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#e5e7eb'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#f3f4f6'}
          >
            <Xmark style={{ width: '24px', height: '24px', color: '#6b7280' }} />
          </button>
          <h4 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#111827', marginBottom: '4px' }}>
            Que tal adicionar algo mais?
          </h4>
          <p style={{ color: '#6b7280', fontSize: '0.9rem', marginBottom: 0 }}>
            {products.length > 1 ? `${currentIndex + 1} de ${products.length} sugestões` : 'Produto que combina com seu pedido'}
          </p>
        </div>

        {/* Body */}
        <div style={{ padding: '32px 24px' }}>
          {loading ? (
            <div style={{ textAlign: 'center', padding: '60px 20px' }}>
              <div className="spinner-border text-primary" role="status" style={{ width: '50px', height: '50px' }}>
                <span className="visually-hidden">Carregando...</span>
              </div>
              <p style={{ marginTop: '20px', color: '#6b7280', fontSize: '1rem' }}>Buscando sugestões...</p>
            </div>
          ) : currentProduct ? (
            <div
              onClick={(e) => {
                e.stopPropagation();
                onSelectProduct(currentProduct);
              }}
              style={{
                backgroundColor: '#fff',
                border: '2px solid #e5e7eb',
                borderRadius: '16px',
                overflow: 'hidden',
                cursor: 'pointer',
                transition: 'all 0.3s',
                boxShadow: '0 4px 6px rgba(0,0,0,0.07)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.15)';
                e.currentTarget.style.borderColor = '#0039ff';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.07)';
                e.currentTarget.style.borderColor = '#e5e7eb';
              }}
            >
              <div style={{ position: 'relative', paddingTop: '50%', backgroundColor: '#f9fafb' }}>
                <img
                  src={getImageUrl(currentProduct)}
                  alt={currentProduct.nome}
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                  onError={(e) => {
                    e.target.src = 'https://grubicons.s3.us-east-1.amazonaws.com/foto-padrao-grub-digital.jpg';
                  }}
                />
                <div style={{
                  position: 'absolute',
                  top: '12px',
                  right: '12px',
                  backgroundColor: '#10b981',
                  color: '#fff',
                  padding: '8px 16px',
                  borderRadius: '20px',
                  fontSize: '1rem',
                  fontWeight: '700',
                  boxShadow: '0 2px 8px rgba(16,185,129,0.3)'
                }}>
                  {formatPrice(currentProduct.em_promocao && currentProduct.promocao_info?.valor_promocional ? currentProduct.promocao_info.valor_promocional : currentProduct.valor)}
                </div>
              </div>
              <div style={{ padding: '24px' }}>
                <h5 style={{ fontSize: '1.3rem', fontWeight: '700', color: '#111827', marginBottom: '12px', lineHeight: '1.3' }}>
                  {currentProduct.nome}
                </h5>
                {currentProduct.descricao && (
                  <p style={{ color: '#6b7280', fontSize: '0.95rem', marginBottom: 0, lineHeight: '1.6' }}>
                    {currentProduct.descricao}
                  </p>
                )}
              </div>
            </div>
          ) : null}

          {/* Navigation Arrows */}
          {products.length > 1 && (
            <div style={{ display: 'flex', justifyContent: 'center', gap: '12px', marginTop: '24px' }}>
              <button
                onClick={handlePrev}
                disabled={currentIndex === 0}
                style={{
                  backgroundColor: currentIndex === 0 ? '#f3f4f6' : '#fff',
                  border: '2px solid #e5e7eb',
                  borderRadius: '12px',
                  padding: '12px 20px',
                  cursor: currentIndex === 0 ? 'not-allowed' : 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  fontSize: '0.9rem',
                  fontWeight: '600',
                  color: currentIndex === 0 ? '#9ca3af' : '#111827',
                  transition: 'all 0.2s',
                  opacity: currentIndex === 0 ? 0.5 : 1
                }}
                onMouseEnter={(e) => {
                  if (currentIndex !== 0) {
                    e.currentTarget.style.borderColor = '#0039ff';
                    e.currentTarget.style.backgroundColor = '#f9fafb';
                  }
                }}
                onMouseLeave={(e) => {
                  if (currentIndex !== 0) {
                    e.currentTarget.style.borderColor = '#e5e7eb';
                    e.currentTarget.style.backgroundColor = '#fff';
                  }
                }}
              >
                <NavArrowLeft style={{ width: '20px', height: '20px' }} />
                Anterior
              </button>
              <button
                onClick={handleNext}
                disabled={currentIndex === products.length - 1}
                style={{
                  backgroundColor: currentIndex === products.length - 1 ? '#f3f4f6' : '#fff',
                  border: '2px solid #e5e7eb',
                  borderRadius: '12px',
                  padding: '12px 20px',
                  cursor: currentIndex === products.length - 1 ? 'not-allowed' : 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  fontSize: '0.9rem',
                  fontWeight: '600',
                  color: currentIndex === products.length - 1 ? '#9ca3af' : '#111827',
                  transition: 'all 0.2s',
                  opacity: currentIndex === products.length - 1 ? 0.5 : 1
                }}
                onMouseEnter={(e) => {
                  if (currentIndex !== products.length - 1) {
                    e.currentTarget.style.borderColor = '#0039ff';
                    e.currentTarget.style.backgroundColor = '#f9fafb';
                  }
                }}
                onMouseLeave={(e) => {
                  if (currentIndex !== products.length - 1) {
                    e.currentTarget.style.borderColor = '#e5e7eb';
                    e.currentTarget.style.backgroundColor = '#fff';
                  }
                }}
              >
                Próximo
                <NavArrowRight style={{ width: '20px', height: '20px' }} />
              </button>
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={{ padding: '16px 24px 24px', display: 'flex', justifyContent: 'center' }}>
          <button
            onClick={async () => {
              setIndoParaCarrinho(true);
              await new Promise(resolve => setTimeout(resolve, 600));
              onGoToCart();
              setIndoParaCarrinho(false);
            }}
            disabled={indoParaCarrinho}
            style={{
              backgroundColor: indoParaCarrinho ? '#ccc' : '#0039ff',
              color: 'white',
              border: 'none',
              borderRadius: '12px',
              padding: '14px 40px',
              fontSize: '1rem',
              fontWeight: '700',
              cursor: indoParaCarrinho ? 'not-allowed' : 'pointer',
              boxShadow: indoParaCarrinho ? 'none' : '0 4px 12px rgba(0,57,255,0.3)',
              transition: 'all 0.3s ease',
              transform: 'translateY(0)',
              opacity: indoParaCarrinho ? 0.6 : 1
            }}
            onMouseEnter={(e) => {
              if (!indoParaCarrinho) {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,57,255,0.4)';
              }
            }}
            onMouseLeave={(e) => {
              if (!indoParaCarrinho) {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,57,255,0.3)';
              }
            }}
          >
            {indoParaCarrinho ? (
              <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Carregando...
              </span>
            ) : 'Ir para o resumo do pedido'}
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default UpselModal;
